import React from 'react';

import { Box } from '@material-ui/core';
import { useDrag } from 'react-dnd';
import { FiMenu } from 'react-icons/fi';

import { AppLink } from '@vyce/core/src/components';
import { FormDoc } from '@vyce/core/src/types';
import { buildFormUrlSegment } from '@vyce/core/src/utils';

interface Props {
  form: FormDoc;
  title?: string;
  dragType: string;
}

export const DraggableFormTitleCell: React.FC<Props> = ({ form, title, dragType }) => {
  const [{ isDragging }, dragRef] = useDrag(
    () => ({
      type: dragType,
      item: { form },
      collect: monitor => ({ isDragging: monitor.isDragging() }),
    }),
    [form, dragType]
  );

  const displayTitle = title || form.title || '';
  const to =
    form.status === 'draft'
      ? `/forms/my-forms/${buildFormUrlSegment(displayTitle, form.id || '')}`
      : `/forms/form-answers/${buildFormUrlSegment(displayTitle, form.id || '')}/summary`;

  return (
    <div ref={dragRef} style={{ cursor: 'grab', width: '100%' }}>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        width="100%"
        style={{ opacity: isDragging ? 0.5 : 1 }}
      >
        <Box display="flex" alignItems="center" gridGap={8} flexGrow={1} minWidth={0}>
          <FiMenu size={14} color="#8F95A3" style={{ flexShrink: 0 }} />
          <Box
            flexGrow={1}
            minWidth={0}
            style={{
              display: '-webkit-box',
              WebkitLineClamp: 3,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
              whiteSpace: 'normal',
              wordBreak: 'break-word',
              lineHeight: 1.4,
              fontWeight: 600,
              fontSize: 14,
            }}
          >
            <AppLink to={to}>{displayTitle}</AppLink>
          </Box>
        </Box>
      </Box>
    </div>
  );
};
